import React from "react";
import camelCase from "lodash/camelCase";
import TextField from "@mui/material/TextField";

import ConfigurableField from "./ConfigurableField";
import AvailableQuantityField from "./fields/AvailableQuantityField";
import RackLocationsField from "./fields/RackLocationsField";
import Input from "../../components/form/Input";
import Select from "../../components/form/Select";
import Autocomplete from "../../components/form/Autocomplete";
import DimensionsField from "./DimensionsField";
import WeightField from "./WeightField";
import FinishField from "./FinishField";
import CategoryField from "./form/CategoryField";
import SubcategoryField from "./form/SubcategoryField";
import MonthYearPicker from "./form/MonthYearPicker";
import MonthDayYearPicker from "./form/MonthDayYearPicker";
import MonthPicker from "./form/MonthPicker";
import YearPicker from "./form/YearPicker";
import ScannerInput from "../../components/form/ScannerInput";
import SerialNumberField from "../../components/form/SerialNumberField";
import CostCenterSelect from "../../components/form/CostCenterSelect";
import OutboundSummary from "../../components/OutboundSummary";
import InboundSummary from "../../components/InboundSummary";
import FieldsAttachments from "../../views/capture/FieldsAttachments";
import OriginQuantityField from "./fields/OriginQuantityField";
import DestinationRoomNumbersScrubber from "./DestinationRoomNumbers/DestinationRoomNumbersScrubber";
import DestinationRoomNumbersCapture from "./DestinationRoomNumbers/DestinationRoomNumbersCapture";
import labels from "../../constants/displayFields";

export default function FormField({ id, type, params, disabled }) {
  switch (type) {
    case "configurable":
      return <ConfigurableField key={id} {...params} disabledForm={disabled} />;
    case "cost_center":
      return <CostCenterSelect key={id} size="small" {...params} disabled={disabled} />;
    case "inbound_summary":
      return <InboundSummary key={id} {...params} disabled={disabled} />;
    case "outbound_summary":
      return <OutboundSummary key={id} {...params} disabled={disabled} />;
    case "attachments":
      return <FieldsAttachments key={id} {...params} disabled={disabled} />;
    case "available_quantity":
      return <AvailableQuantityField {...params} disabledForm={disabled} />;
    case "rack_locations":
      return <RackLocationsField {...params} disabledForm={disabled} />;
    case "input":
      return <Input key={id} {...params} disabled={disabled} />;
    case "select":
      return <Select key={id} size="small" {...params} disabled={disabled} />;
    case "text_field":
      return <TextField key={id} {...params} disabled={disabled || params.disabled} />;
    case "autocomplete":
      return <Autocomplete key={id} {...params} disabled={disabled} />;
    case "dimensions":
      return <DimensionsField key={id} {...params} disabled={disabled} />;
    case "weightField":
      return <WeightField key={id} {...params} disabled={disabled} />;
    case "finishes":
      return <FinishField key={id} {...params} disabled={disabled} />;
    case "category":
      return <CategoryField key={id} {...params} disabled={disabled} />;
    case "subcategory":
      return <SubcategoryField key={id} {...params} disabled={disabled} />;
    case "monthYearPicker":
      return <MonthYearPicker key={id} {...params} disabled={disabled} />;
    case "monthDayYearPicker":
      return <MonthDayYearPicker key={id} {...params} disabled={disabled} />;
    case "monthPicker":
      return <MonthPicker key={id} {...params} disabled={disabled} />;
    case "yearPicker":
      return <YearPicker key={id} {...params} disabled={disabled} />;
    case "serialNumberField":
      return <SerialNumberField key={id} {...params} disabled={disabled} />;
    case "scannerInput":
      return <ScannerInput key={id} {...params} disabled={disabled} />;
    case "origin_quantity":
      return <OriginQuantityField {...params} disabled={disabled} />;
    case "destination_room_number":
      return params.captureType === "scrubber" ? (
        <DestinationRoomNumbersScrubber
          type={params.captureType}
          entity={params.asset}
          disabled={disabled || params.disabled}
        />
      ) : (
        <DestinationRoomNumbersCapture
          type={params.captureType}
          entity={params.asset}
          disabled={disabled || params.disabled}
        />
      );
    default:
      if (!id && !params?.name) return null;
      return (
        <Input
          key={id}
          type={params?.inputType || "autoExpand"}
          name={params?.name || camelCase(id)}
          label={params?.label || labels[id] || id}
          disabled={disabled || params?.disabled}
          showNAButton={params?.showNAButton}
        />
      );
  }
}
